import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

import { OverrideReactSelectStyles } from '../../../utils/select/override-react-select-styles';
import MenuList from './components/MenuList';
import OptionLabel from './components/OptionLabel';

import styles from './styles.module.styl';

const LoadingMessage = () => null;

/**
 * @typedef {Object} SelectOption
 * @property {string|number} value
 * @property {string} label
 */

/**
 * @typedef {'input-change'|'menu-close'|'set-value'|'clear'} InputAction
 */

/**
 * @typedef {(inputValue: string, meta: { action: InputAction }) => void} OnInputChange
 */

/**
 * @typedef {(option: SelectOption|null) => void} OnChange
 */

/**
 * @typedef {Object} AsyncPaginatedSelectProps
 * @property {OnInputChange=} handleInputChange
 * @property {OnChange=} onChange
 * @property {SelectOption[]=} options
 * @property {SelectOption|null=} value
 * @property {()=>void=} onMenuScrollToBottom
 * @property {boolean=} isLoading
 * @property {string=} label
 * @property {string=} placeholder
 */

/**
 * @param {AsyncPaginatedSelectProps} props
 */
const AsyncPaginatedSelect = ({
  handleInputChange,
  isLoading,
  label,
  onChange,
  onMenuScrollToBottom,
  options = [],
  placeholder,
  ...other
}) => {
  return (
    <div>
      {label && <label className={styles.label}>{label}</label>}

      <Select
        components={{ MenuList, LoadingMessage }}
        filterOption={null}
        isLoading={isLoading}
        menuPlacement="auto"
        onChange={onChange}
        onInputChange={handleInputChange}
        onMenuScrollToBottom={onMenuScrollToBottom}
        options={options}
        placeholder={placeholder}
        styles={OverrideReactSelectStyles}
        formatOptionLabel={OptionLabel}
        {...other}
      />
    </div>
  );
};

AsyncPaginatedSelect.propTypes = {
  handleInputChange: PropTypes.func,
  isLoading: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func,
  onMenuScrollToBottom: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string,
    }),
  ),
  placeholder: PropTypes.string,
  value: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
  }),
};

export default AsyncPaginatedSelect;



// WEBPACK FOOTER //
// ./src/components/common/AsyncPaginatedSelect/index.jsx